import React from 'react';

const Plus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M17 6.5C17 5.94772 16.5523 5.5 16 5.5C15.4477 5.5 15 5.94772 15 6.5V14.9999L6.50003 14.9999C5.94774 14.9999 5.50003 15.4476 5.50003 15.9999C5.50003 16.5522 5.94775 16.9999 6.50003 16.9999L15 16.9999V25.5C15 26.0523 15.4477 26.5 16 26.5C16.5523 26.5 17 26.0523 17 25.5V16.9999L25.5 16.9998C26.0523 16.9998 26.5 16.5521 26.5 15.9998C26.5 15.4475 26.0523 14.9998 25.5 14.9998L17 14.9999V6.5Z" />
  </svg>
);

export default Plus;
